import { ProviderMedicalRole } from '@uplift/types';

/**
 * Psychiatrist rematching (MVP-9055) is built but disabled in production.
 * Flip to `true` to re-enable it everywhere at once.
 */
export const PSYCHIATRIST_REMATCH_ENABLED = true;

export const isRematchEligibleRole = (medicalRole?: ProviderMedicalRole) => {
  if (medicalRole === ProviderMedicalRole.therapist) {
    return true;
  }

  return PSYCHIATRIST_REMATCH_ENABLED && medicalRole === ProviderMedicalRole.psychiatrist;
};
